export const removeLetters = str => str.replace(/[a-zA-Z]/g, '').trim();
